import classNames from 'classnames'
import { cloneDeep } from 'lodash'
import React, { useState, useEffect } from 'react'
import { Table, Panel, List, FlexboxGrid, Row, Col } from 'rsuite'
import { Icon, IconButton, ButtonGroup, Modal, Button } from 'rsuite'

export default function ResultView({ schema, onEdit, onDelete, onSelectConnection, isSubProject, ...props }) {
  const { isEdit, isCoordinator } = props
  const datas = schema?.indicatorsResult?.value || []
  // const [datas, setDatas] = useState(schema?.indicatorsResult?.value || [])
  // console.log('datas', JSON.stringify(datas))
  const [isDelete, setIsDelete] = useState(false)
  const [selectDelete, setSelectDelete] = useState()
  const [hideList, setHideList] = useState([])

  const { Column, HeaderCell, Cell } = Table

  const getDataList = () => {
    let _dataList = []

    datas.forEach((item, index) => {
      _dataList.push({ show: true, ...item, index: index })

      let isHide = hideList.includes(item.id)

      item?.indicatorsList?.forEach((subItem, index) => {
        _dataList.push({
          show: !isHide,
          hideEdit: true,
          index: index,
          parent: item.id,
          ...subItem,
        })
      })
    })

    return _dataList
  }

  const onExPandChange = (id) => {
    let list = cloneDeep(hideList)
    const index = list?.indexOf(id)
    if (index > -1) {
      list.splice(index, 1)
    } else {
      list.push(id)
    }

    setHideList(list)
  }

  const findObjectiveOptions = (id) => {
    if (id) {
      const objectiveValue = schema?.objective?.options.find((objt) => objt.value === id)

      return `${objectiveValue?.label}`
    } else {
      return ''
    }
  }

  const findIndicatorType = (type) => {
    const indicatorsValue = schema?.indicators?.indicatorType?.options.find(
      (typeOption) => typeOption.value == type
    )

    return ` (${indicatorsValue.label}) `
  }

  return (
    <Panel eventKey={2} bodyFill>
      <Table data={[]} height={40}>
        <Column flexGrow={1}>
          <HeaderCell>ผลลัพธ์ของวัตถุประสงค์</HeaderCell>
          <Cell />
        </Column>
      </Table>
      <div style={{ height: 400, width: '100%', overflowY: 'scroll' }}>
        <List hover>
          {getDataList().map((item, index) => (
            <>
              {item.show && (
                <List.Item key={item['id']} index={index}>
                  <Row>
                    <Col
                      xs={24}
                      sm={24}
                      md={24}
                      lg={24}
                      // align="center"
                      // style={{ width: 30, cursor: 'pointer' }}
                      // onClick={() => {
                      //   onExPandChange(item.id)
                      // }}
                    >
                      {item.objective && (
                        <>
                          <b>
                            <u>วัตถุประสงค์</u>
                          </b>{' '}
                          : {findObjectiveOptions(item.objective)}
                        </>
                      )}
                    </Col>
                  </Row>

                  <Row style={item.objective && { marginTop: 20 }}>
                    {!item.hideEdit ? (
                      <>
                        <Col
                          xs={1}
                          sm={1}
                          md={1}
                          lg={1}
                          align="center"
                          style={{ width: 30, cursor: 'pointer' }}
                          onClick={() => {
                            onExPandChange(item.id)
                          }}
                        >
                          <Icon
                            icon={hideList.includes(item.id) ? 'angle-right' : 'angle-down'}
                            style={{ color: '#2ca888' }}
                          />
                        </Col>
                        <Col
                          xs={isEdit ? 18 : 23}
                          sm={isEdit ? 18 : 23}
                          md={isEdit ? 18 : 23}
                          lg={isEdit ? 18 : 23}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            onExPandChange(item.id)
                          }}
                        >
                          <div style={{ textAlign: 'left' }}>
                            <b style={{ color: '#2ca888' }}>
                              <u>ผลลัพธ์ของวัตถุประสงค์</u>
                            </b>
                            {' : ' + item.objectiveResult}
                          </div>
                        </Col>

                        {isEdit && !isCoordinator && (
                          <Col xs={4} sm={4} md={4} lg={4} style={{ width: 200 }} align="right">
                            <div
                              style={{
                                width: 200,
                                // position: 'absolute', right: 0, top: -6
                              }}
                            >
                              <ButtonGroup style={{ marginRight: 5 }}>
                                <IconButton
                                  appearance="ghost"
                                  className="rs-btn-ghost-edit"
                                  icon={<Icon icon="edit" className="bt-gost-icon-radius-edit" />}
                                  onClick={(e) => onEdit(item)}
                                >
                                  แก้ไข
                                </IconButton>
                                <IconButton
                                  appearance="ghost"
                                  className="rs-btn-ghost-cancel"
                                  icon={
                                    <Icon
                                      icon="trash-o"
                                      className="bt-gost-icon-none-radius-cancel"
                                    />
                                  }
                                  onClick={(e) => {
                                    setIsDelete(true)
                                    setSelectDelete(item.id)
                                  }}
                                >
                                  ลบ
                                </IconButton>
                              </ButtonGroup>
                            </div>
                          </Col>
                        )}
                      </>
                    ) : (
                      <div style={{ marginLeft: 40, marginRight: 10 }}>
                        <Col xs={20} sm={20} md={20} lg={20}>
                          <div>
                            <p style={{ marginLeft: 20 }}>
                              <b>
                                <u> ตัวชี้วัดที่ {item.index + 1}</u>
                              </b>{' '}
                              <i> {findIndicatorType(item.indicatorType)}</i> :{' '}
                              {item[schema.indicators.name]}{' '}
                              {item[schema.indicators.count.name] &&
                                schema.indicators.count.label +
                                  ' ' +
                                  item[schema.indicators.count.name]}{' '}
                              {item[schema.indicators.unit.name] &&
                                item[schema.indicators.unit.name]}
                              {' '}
                              {(item.indicatorType && item.indicatorResult) ?
                                item.indicatorResult : ''}
                                
                            </p>
                            {schema.indicators.dataCollection && (
                              <p style={{ marginLeft: 30 }}>
                                <u>{schema.indicators.dataCollection.label}</u>
                                {' : '}
                                {item[schema.indicators.dataCollection.name] || ''}
                              </p>
                            )}

                            {schema.indicators.dataCollectionMethod && (
                              <p style={{ marginLeft: 30 }}>
                                <u>{schema.indicators.dataCollectionMethod.label}</u>
                                {' : '}
                                {item[schema.indicators.dataCollectionMethod.name] || ''}
                              </p>
                            )}
                          </div>
                        </Col>
                        {isEdit && item.indicatorType == 1 && !isSubProject && (
                          <Col xs={4} sm={4} md={4} lg={4} align="right">
                            <div
                              
                            >
                              <IconButton
                                appearance="ghost"
                                className="rs-btn-ghost"
                                icon={<Icon icon="edit" className="bt-gost-icon-radius" />}
                                onClick={() => {
                                  // setIsShowConnection(true)
                                  onSelectConnection(item)
                                }}
                              >
                                ความเชื่อมโยง
                              </IconButton>
                            </div>
                          </Col>
                        )}
                      </div>
                    )}
                  </Row>
                </List.Item>
              )}
            </>
          ))}
        </List>
      </div>

      <Modal
        backdrop="static"
        size="xs"
        show={isDelete}
        onHide={(e) => {
          setIsDelete(false)
          setSelectDelete('')
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'ยืนยันการลบ ' + (schema.buttonText ? schema.buttonText : '')}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              onDelete(selectDelete)
              setIsDelete(false)
              setSelectDelete('')
            }}
            appearance="primary"
          >
            ยืนยัน
          </Button>
          <Button
            onClick={(e) => {
              setIsDelete(false)
              setSelectDelete('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </Panel>
  )
}
